import Box from "@mui/material/Box";
import InputLabel from "@mui/material/InputLabel";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";
import cloneDeep from "lodash.clonedeep";
import isEqual from "lodash.isequal";
import { useCallback, useState, useEffect } from "react";
import { useSelector } from "react-redux";
import AppDrawer from "./catalogue-drawer";
import { AppConfig } from "../../../../../Config/app-config";
// components
import UIButton from "../../../../FlowBuilder/Components/Button";
// slice
import { useAppDispatch, useAppSelector } from "../../../../../Store";
import { UpdateSelectedProducts, useCurrentBot } from "../../../../../Store/Slices/DashboardSlices";
import {
  getActiveNode,
  getLanguage,
  updateModifiedData,
} from "../../../Slices/main.slice";
import { Icon } from "@mui/material";
// utils
import { getInteractiveMessageData, getNodeConfig } from "../../../Utils";
import {
  convertWhatsappToHtmlText,
  getChannelWiseText,
} from "../../../Utils/editor";
import CatalogueButtonsList from "../../Buttons/catalogue-button-list";
import UISelect from "../../Date/select";
import CatalogueInteractiveContent from "../common/catalogue-interactive";
import Button from '../../../../FlowBuilder/Components/Button'
import { set } from "lodash";
import MultipleCatalogueDrawer from './multi-catalog'
import AllCatalogService from './allcatalog'
import getInteractiveCatalogueData from "../../../Utils/getInteractiveCatalogueData";
import { group } from "console";
import { useSelectedProducts } from "../../../../../Store/Slices/DashboardSlices";
import { useAuthStore } from "../../../../../Store/Slices/AuthSlice";
// Define NodeProps interface (if not imported elsewhere)
interface NodeProps {
  node: {
    response: any;
    nodeId: string;
    subType: string;
    // other properties as needed
  };
}

const InteractiveCatalogue = (props: NodeProps) => {
  const { node } = props;
  console.log("NODE", node)
  const language = useSelector(getLanguage);
  const { data: authData, userConfig } = useAppSelector(useAuthStore);
  console.log("userConfig",userConfig);
  const { interactive } = getInteractiveMessageData(node, language);

  // const { interactive } = node.response && node.response.length > 0
  //   ? getInteractiveCatalogueData(node, language)
  //   : {
  //     interactive: {
  //       header: "",
  //       body: "",
  //       footer: "",
  //       action: { catalog_id: null, product_retailer_id: null }
  //     }
  //   };
  const [header, updateHeader] = useState(interactive?.header || "");
  const [body, updateBody] = useState(
    convertWhatsappToHtmlText(interactive?.body) || ""
  );
  const [footer, updateFooter] = useState(interactive?.footer || "");
  const [buttonsList, updateButtonsList] = useState<any[]>(
    interactive?.action?.buttons || []
  );



  const activeNode = useSelector(getActiveNode);
  const currentBot = useSelector(useCurrentBot);
  const nodeConfig = getNodeConfig(node.subType);
  const validation = currentBot?.channel
    ? nodeConfig.validation[currentBot?.channel]
    : {};
  const charLimit = validation?.charLimit;
  const dispatch = useAppDispatch();

  const CHARACTER_LIMITS = {
    header: validation?.headerMaxLimit,
    body: validation?.bodyMaxLimit,
    footer: validation?.footerMaxLimit,
  };

  const isActiveNode = activeNode === node.nodeId;

  const sendOptions = [
    { label: "Catalogue", value: "product" },
    { label: "Single Product", value: "catalogue" },
    { label: "Multiple Product", value: "product_list" },
  ];
  const previousSelectedProducts = useSelector(useSelectedProducts);
  const [send, setSend] = useState<string>("product");

  const [open, setOpen] = useState<boolean>(false);
  const [selectedProducts, setSelectedProducts] = useState<any>([]);
  const [action, setAction] = useState<any>();

  useEffect(() => {
    setSend(node?.response || node?.response?.[0]?.interactive?.type ?  node?.response?.[0]?.interactive?.type : sendOptions?.[0]?.value)
    setSelectedProducts(node?.response?.[0]?.interactive?.action?.product)
    setAction(node?.response?.[0]?.interactive?.action)
  }, [])


  const handleDebounceFn = (
    headerData: any,
    bodyData: string,
    footerData: string,
    list: any[],
    actionData?: any,
    type?: string
  ) => {
    // const productData = products ? products : selectedProducts; // ✅ Default to empty array
    let data: any = {};
    console.log("action----------------->", actionData, action, send);

    // if (send === "catalogue") {
    //   data = {
    //     type: "product",
    //     header: headerData,
    //     footer: footerData,
    //     body: getChannelWiseText(bodyData, "whatsapp"),
    //     action: {
    //       catalog_id: productData?.catalog_id || "YET_TO_GET",
    //       product_retailer_id: productData?.length > 0 ? productData?.[0].retailer_id : "", // ✅ Safe check
    //       product : productData
    //     },
    //   };
    // } else if (send === "product") {
    //   data = {
    //     type: "catalogue",
    //     header: headerData,
    //     footer: footerData,
    //     body: getChannelWiseText(bodyData, "whatsapp"),
    //     action: {
    //       name: "catalog_message",
    //       parameters: {
    //         thumbnail_product_retailer_id: productData?.length > 0 ? productData?.[0].retailer_id : "", // ✅ Safe check
    //         product : productData
    //       },
    //     },
    //   };
    // } 
    // else {
    //   const ungroupedProducts = productData?.ungrouped ?? [];
    //   const groupedProducts = productData?.groups ?? [];

    //   let sections: { title: string; product_items: { product_retailer_id: string }[] }[] = [];

    //   if (ungroupedProducts.length) {
    //     sections.push({
    //       title: "Products",
    //       product_items: ungroupedProducts.map((product: any) => ({
    //         product_retailer_id: product?.retailer_id ?? "", // ✅ Safe check
    //       })),
    //     });
    //   }

    //   groupedProducts.forEach((group: any) => {
    //     sections.push({
    //       title: group.name || "Unnamed Group",
    //       product_items: group.products?.map((product: any) => ({
    //         product_retailer_id: product?.retailer_id ?? "", // ✅ Safe check
    //       })),
    //     });
    //   });

    //   data = {
    //     type: "product_list",
    //     header: headerData,
    //     footer: footerData,
    //     body: getChannelWiseText(bodyData, "whatsapp"),
    //     action: {
    //       catalog_id: productData?.catalog_id || "YET_TO_GET",
    //       sections: sections,
    //     },
    //   };
    // }    
    data = {
      type: actionData?.sections ? "product_list" : actionData?.parameters ? "catalogue" : "product",
      header: headerData,
      footer: footerData,
      body: getChannelWiseText(bodyData, "whatsapp"),
      action: actionData ? { ...actionData } : { ...action }
    };
    console.log("Dispatched Data", data);

    dispatch(updateModifiedData([{ interactive: data, type: "whatsapp_catalogue" }]));
    return data;
  };

  const [sendPreSelectedData, setSendPreSelectedData] = useState<any>();


  //sending Preselected Products using api
  const sendPreSelected = () => {
    if (node?.response[0].interactive?.type === "catalogue") {
      const productIds = [];

      const pid = node?.response[0].interactive?.action?.parameters?.thumbnail_product_retailer_id;
      productIds.push(pid);
      console.log("inside catalogue", productIds);
      setSendPreSelectedData(productIds)

      return productIds;

    } else if (node?.response[0].interactive?.type === "product") {
      const productIds = [];
      const pid = node?.response[0].interactive.action.product_retailer_id;
      productIds.push(pid);
      console.log("inside Product", productIds);
      setSendPreSelectedData(productIds);

      return productIds;

    } else if (node?.response[0].interactive?.type === "product_list") {

      const productsGroups: any[] = [];

      const sectionObject = node?.response[0].interactive?.action?.sections?.map((group: any) => {
        if (!group?.product_items) return null; // Ensure product_items exists
        return {
          title: group?.title,
          productIds: group?.product_items?.map((item: any) => item?.product_retailer_id),
        };
      }).filter(Boolean); // Removes null values


      if (sectionObject.length > 0) {
        productsGroups.push(...sectionObject);
      }

      console.log("inside Multiple", productsGroups);

      setSendPreSelectedData(productsGroups);
      return productsGroups;

    }


  }

  // useEffect(() => {
  //   if (node?.response?.[0]?.interactive) {
  //     const preselectedData = sendPreSelected();
  //     if (!isEqual(preselectedData, sendPreSelectedData)) {
  //       setSendPreSelectedData(preselectedData);
  //     }
  //   }
  // }, [node?.response?.[0]?.interactive]);




  const handleResetSelected = () => {
    setSendPreSelectedData([]);
  }
  // Update debounce function when selectedProducts changes
  // const debounceFn = useCallback(
  //   (headerData: string | any, bodyData: string, footerData: string, list: any[], products?: any) => {
  //     handleDebounceFn(headerData, bodyData, footerData, list, products);
  //   },
  //   [selectedProducts, dispatch]
  // );
  const debounceFn = useCallback(handleDebounceFn, []);


  // Effect to update data when selectedProducts changes
  // useEffect(() => {
  //   if (selectedProducts) {
  //     debounceFn(header, body, footer, buttonsList, selectedProducts);
  //   }
  // }, [selectedProducts]);

  const handleButtonLabelChange = (
    label: string,
    activeButtonIdx: number | null
  ) => {
    console.log("label", label);
    console.log("activeButtonIdx", activeButtonIdx);
    if (activeButtonIdx !== null) {
      const tempButtonList = cloneDeep(buttonsList);
      const newState = tempButtonList.map((button: any, index: number) => {
        if (index === activeButtonIdx) {
          return {
            ...button,
            value: {
              ...button.value,
              ...{ text: label.substring(0, charLimit) },
            },
          };
        }
        return button;
      });
      updateButtonsList(newState);
      debounceFn(header, body, footer, newState, selectedProducts);
    }
  };

  const getById = (id: string) =>
    buttonsList.find((button: any) => button.id === id);

  const handleButtonSave = (updatedAction: any) => {
    if (updatedAction.id) {
      const previousValue = getById(updatedAction.id);

      const isDifferent = isEqual(previousValue, updatedAction);

      if (previousValue) {
        if (!isDifferent) {
          const tempButtonList = cloneDeep(buttonsList);
          const newState = tempButtonList.map((button: any, index: number) => {
            if (button.id === updatedAction.id) {
              return {
                ...button,
                type: updatedAction.type,
                value: {
                  ...button.value,
                  ...{
                    text: updatedAction.value.text.substring(0, charLimit),
                    url: updatedAction.value.url,
                    ...updatedAction.value,
                  },
                },
                ...(updatedAction.type === "transfer_to_faqs" && {
                  text: updatedAction.text,
                }),
              };
            }
            return button;
          });
          updateButtonsList(newState);
          debounceFn(header, body, footer, newState, selectedProducts);
        }
        return;
      } else {
        const updatedBtn = [...buttonsList, ...[updatedAction]];
        updateButtonsList(updatedBtn);
        debounceFn(header, body, footer, updatedBtn, selectedProducts);
      }
    }
  };

  const handleButtonDelete = (activeButton: any, index: number) => {
    const tempButtonList = cloneDeep(buttonsList);
    if (tempButtonList.length === 1) return;
    if (activeButton.id) {
      const newState = tempButtonList.filter(
        (button: any) => button.id !== activeButton.id
      );
      updateButtonsList(newState);
      debounceFn(header, body, footer, newState, selectedProducts);
      return;
    }
    /* NOTE: in case button doesn't have ids. delete operation will perform on the basis of index */
    if (index !== -1) {
      tempButtonList.splice(index, 1);
      updateButtonsList(tempButtonList);
      debounceFn(header, body, footer, tempButtonList, selectedProducts);
      return;
    }
  };

  const handlePreviewButtonClick = () => {
    // setPreview(false);
  };

  const handleFooterChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    if (value.length > CHARACTER_LIMITS.footer) return;
    updateFooter(value);
    debounceFn(header, body, value, buttonsList, selectedProducts);
  };

  const handleBodyTextChange = (bodyText: string) => {
    updateBody(bodyText);
    debounceFn(header, bodyText, footer, buttonsList, selectedProducts);
  };


  const handleHeaderChange = (data: any) => {  
    let payload =  {
      "type": "text",
      "text": data?.target?.value
  }
    updateHeader(payload);
    debounceFn(payload, body, footer, buttonsList, selectedProducts);
  };

  const handleOrderChange = (buttonsList: any) => {
    const tempButtonList = cloneDeep(buttonsList);
    updateButtonsList(tempButtonList);
    debounceFn(header, body, footer, tempButtonList, selectedProducts);
    return;
  };

  const handleTypeChange = (event: any) => {
    console.log(event.target.value);
    setSend(event.target.value);
    if (event.target.value === "product") {
      setAction({
        name: "catalog_message",
        product: selectedProducts,
        parameters: {
          thumbnail_product_retailer_id: selectedProducts?.length > 0 ? selectedProducts?.[0].retailer_id : "", // ✅ Safe check
        }
      })
      debounceFn(header, body, footer, buttonsList, {
        name: "catalog_message",
        product: selectedProducts,
        parameters: {
          thumbnail_product_retailer_id: selectedProducts?.length > 0 ? selectedProducts?.[0].retailer_id : "", // ✅ Safe check
        },
      });
    }
    if (event.target.value === "catalogue") {
      setAction({
        catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
        product_retailer_id: selectedProducts?.length > 0 ? selectedProducts?.[0].retailer_id : "", // ✅ Safe check
        product: selectedProducts
      })
      debounceFn(header, body, footer, buttonsList, {
        catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
        product_retailer_id: selectedProducts?.length > 0 ? selectedProducts?.[0].retailer_id : "", // ✅ Safe check
        product: selectedProducts
      });
    }
    if(event.target.value === "product_list"){
      setAction({
        catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
        sections : []
      })
      debounceFn(header, body, footer, buttonsList, {
        catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
        sections : []
      });
    }
  };

  const handleOpen = async () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handlopeneMulitpleCatalogueModal = () => {
    setOpen(true);
  };

  const handleCloseMultipleCatalogueModal = () => {
    setOpen(false);
  };

  const handleSelectedDataForAllCatalog = async (data: any) => {
    setSelectedProducts({
      name: "catalog_message",
      product: data,
      parameters: {
        thumbnail_product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      },
    });
    setOpen(false);
    setAction({
      name: "catalog_message",
      product: data,
      parameters: {
        thumbnail_product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      },
    })
    debounceFn(header, body, footer, buttonsList, {
      name: "catalog_message",
      product: data,
      parameters: {
        thumbnail_product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      },
    })
    // debounceFn(header, body, footer, buttonsList, data);
  };

  const handleSelectedDataForOneProduct = async (data: any) => {
    setSelectedProducts({
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      product: data

    });
    setOpen(false);
    setAction({
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      product: data

    })
    debounceFn(header, body, footer, buttonsList, {
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      product_retailer_id: data?.length > 0 ? data?.[0].retailer_id : "", // ✅ Safe check
      product: data
    })
    // debounceFn(header, body, footer, buttonsList, data);
  };

  const handleSelectedDataForMultiProduct = async (data: any,thumbnailProduct:any) => {
    setSelectedProducts({
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      sections : data

    });
    setOpen(false);
    setAction({
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      sections : data

    })
    debounceFn(header, body, footer, buttonsList, {
      catalog_id: userConfig?.payload?.catalogue_config?.catalogue_id || "",
      sections : data
    })
    // debounceFn(header, body, footer, buttonsList, data);
  };
  // const previousProductSetter = async (data: any, type: string) => {
  //   let selectedProducts: any[] = [];

  //   if (type === "single_product" || type === "catalogue") {
  //     selectedProducts = data.length > 0 ? [data[0]] : [];
  //   } else if (type === "multiple_product") {
  //     const collectionProducts = data?.collections || [];
  //     const groupedProducts = data?.groups?.flatMap((group: { products: any[] }) => group.products || []) || [];
  //     const ungroupedProducts = data?.ungrouped || [];

  //     selectedProducts = [...collectionProducts, ...groupedProducts, ...ungroupedProducts];
  //   }

  //   const formattedData = { selectedType: type, products: selectedProducts };

  //   dispatch(UpdateSelectedProducts(formattedData)); // ✅ Dispatch to Redux

  //   return formattedData; // ✅ Return in required format
  // };





  // const getSelectedProductsCount = () => {
  //   if (!selectedProducts) return 0;

  //   if (send === "single_product" || send === "catalogue") {
  //     return selectedProducts.catalog_id ? 1 : 0;
  //   } else {
  //     // For multiple products
  //     const ungroupedCount = selectedProducts?.ungrouped?.length || 0;
  //     let groupedCount = 0;

  //     if (selectedProducts?.groups && selectedProducts.groups.length > 0) {
  //       selectedProducts.groups.forEach((group: any) => {
  //         groupedCount += group.products?.length || 0;
  //       });
  //     }

  //     return ungroupedCount + groupedCount;
  //   }
  // };

  // const productCount = getSelectedProductsCount();
  const getPreviousProductCount = () => {
    if (!previousSelectedProducts?.products) return 0;
    return previousSelectedProducts.products.length;
  };

  const previousProductCount = getPreviousProductCount();

  const [previousType, setPreviousType] = useState<string>('');
  // useEffect(() => {
  //   if (previousSelectedProducts) {
  //     setPreviousType(previousSelectedProducts.selectedType || send);
  //   }
  // }, [previousSelectedProducts])






  console.log("selectedProducts", selectedProducts,send);

  return (
    <Box sx={{ p: "16px" }}>
      {isActiveNode ? (
        <>
          <UISelect
            value={send}
            options={sendOptions}
            onChange={handleTypeChange}
            placeholder="Select Send Format"
          />
          <CatalogueInteractiveContent
            characterLimit={CHARACTER_LIMITS}
            header={header}
            body={body}
            footer={footer}
            onBodyChange={handleBodyTextChange}
            onHeaderChange={handleHeaderChange}
            onFooterChange={handleFooterChange}
            isActive={isActiveNode}
            type={send}
          />

          {selectedProducts?.length > 0 ? (
            <Box sx={{ my: 2, alignItems: "center", gap: 2, marginTop: "-40px" }}>
              <div>
                <img style={{ width: "35%" }} src={selectedProducts?.[0]?.
                  image_url
                }></img>
                <Typography variant="body2">
                  {selectedProducts?.length > 0 ? selectedProducts?.[0]?.name : ""}
                </Typography>
              </div>
              <UIButton
                variant="outlined"
                size="small"
                onClick={send === "mconvertWhatsappToHtmlTextultiple_product" ? handlopeneMulitpleCatalogueModal : handleOpen}
                style={{ marginBottom: "12px", marginTop: "12px" }}
              >
               { send === "product_list" ? "Choose Multiple Products" : "Change Selection"}
              </UIButton>
            </Box>
          ) : (
            send === "product" || send === "catalogue" ? (
              <UIButton
                variant="outlined"
                size="medium"
                onClick={handleOpen}
              >
                Choose Catalogue
              </UIButton>
            ) : (
              <UIButton
                variant="outlined"
                size="medium"
                onClick={handlopeneMulitpleCatalogueModal}
              >
                Choose Multiple Products
              </UIButton>
            )
          )}

          <Box sx={{ mx: "-16px", mt: "-16px" }}>
            {/* <CatalogueButtonsList
              isActiveNode={activeNode}
              buttonsList={activeNode ? buttonsList : []}
              onLabelChange={handleButtonLabelChange}
              onButtonSave={handleButtonSave}
              onPreviewButtonClick={handlePreviewButtonClick}
              onButtonDelete={handleButtonDelete}
              nodeType={node.subType}
              minLimit={1}
              onOrderChange={(buttonsList: any) =>
                handleOrderChange(buttonsList)
              }
            /> */}
          </Box>
        </>
      ) : (
        <>
          {header?.type === "text" && (
            <Typography variant="body1">{header.text}</Typography>
          )}
          {body && body !== "" && (
            <Typography variant="body1">{parse(body)}</Typography>
          )}
          {footer && footer !== "" && (
            <Typography variant="caption">{footer}</Typography>
          )}
          {buttonsList.length > 0 && (
            <Box sx={{ mx: "-16px" }}>
              {/* <CatalogueButtonsList
                isActiveNode={isActiveNode}
                buttonsList={buttonsList}
                onLabelChange={handleButtonLabelChange}
                onButtonSave={handleButtonSave}
                onPreviewButtonClick={handlePreviewButtonClick}
                onButtonDelete={handleButtonDelete}
                nodeType={node.subType}
                minLimit={1}
                onOrderChange={() => { }}
              /> */}
            </Box>
          )}
        </>
      )}

      {open
        ?
        send === "product" && open ?
          <AllCatalogService
            open={open}
            onClose={handleClose}
            // products={products}
            type={send}
            // loading={loading}
            node={node}
            sendSelectedData={handleSelectedDataForAllCatalog}
            selectedProductsList={selectedProducts}
          // onConfirm={() => debounceFn(header, body, footer, buttonsList, selectedProducts)}
          // preSelected={sendPreSelectedData}
          // resetSelected={handleResetSelected}
          />

          : send === "catalogue" && open ?
            <AllCatalogService
              open={open}
              onClose={handleClose}
              // products={products}
              type={send}
              // loading={loading}
              node={node}
              sendSelectedData={handleSelectedDataForOneProduct}
              selectedProductsList={selectedProducts}
            // onConfirm={() => debounceFn(header, body, footer, buttonsList, selectedProducts)}
            // preSelected={sendPreSelectedData}
            // resetSelected={handleResetSelected}
            /> :
            send === "product_list" && open ?
              <MultipleCatalogueDrawer
                open={open}
                onClose={handleClose}
                node={node}
                type={send}
                sendSelectedData={handleSelectedDataForMultiProduct}
                isThumbnail={false}
              // loading={loading}
              // products={products}
              // pagination={pagination}
              />
              : null
        : null}
    </Box >
  );
};

export default InteractiveCatalogue;